import { getCompany, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createIncomeUpdatedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.INCOME_UPDATED,
        ...getUserAndEventTime(),
        ...getCompany(),
        publicToken: 'PUBLIC_TOKEN',
        product: 'deposit',
        metadata: {
            orderId: '123'
        },
        task: '5e30afde097146a8fc3d5cec',
        taskWorkflow: '5e30afde097146a8fc3d5ceb',
        data: {
            previousStatus: 'processing',
            status: 'completed',
            distributionType: 'fixed',
            distributionAmount: 25
        }
    };
};
//# sourceMappingURL=income-updated.js.map